import React from "react";
import { Link } from "react-router-dom";

const DwellingImg = () => {
  const listings = [
    {
      title: "Appartment, Condo, Loft",
      image: "images/all/homedwelling11.webp",
      link: "/by-dwelling/details/Loft",
    },

    {
      title: "Beachfront",
      image: "images/all/homedwelling1.webp",
      link: "/by-dwelling/details/Beachfront",
    },
    {
      title: "Bed & Breakfast",
      image: "images/all/homedwelling2.webp",
      link: "/by-dwelling/details/Bed_Breakfast",
    },
    {
      title: "Cabin",
      image: "images/all/homedwelling3.webp",
      link: "/by-dwelling/details/Cabin",
    },
    {
      title: "Campsite",
      image: "images/all/homedwelling4.webp",
      link: "/by-dwelling/details/Campsite",
    },

    {
      title: "Farm",
      image: "images/all/homedwelling6.webp",
      link: "/by-dwelling/details/Farm",
    },
    {
      title: "Hangar",
      image: "images/all/homedwelling7.webp",
      link: "/by-dwelling/details/",
    },
    {
      title: "Hangar Home",
      image: "images/all/homedwelling8.webp",
      link: "/by-dwelling/details/Hangar_Home",
    },
    {
      title: "House",
      image: "images/all/homedwelling9.webp",
      link: "/by-dwelling/details/House",
    },
    {
      title: "Lakefront",
      image: "images/all/homedwelling10.webp",
      link: "/by-dwelling/details/Lakefront",
    },

    {
      title: "Mansion",
      image: "images/all/homedwelling12.webp",
      link: "/by-dwelling/details/Mansion",
    },
    {
      title: "RV",
      image: "images/all/rv.png",
      link: "/by-dwelling/details/RV",
    },
    {
      title: "RV Pad",
      image: "images/all/rvpad.png",
      link: "/by-dwelling/details/RV",
    },
    {
      title: "Tiny Home",
      image: "images/all/homedwelling14.webp",
      link: "/by-dwelling/details/Tiny_Home",
    },
  ];

  return (
    <div className="bg-[#f6f8fa] py-20">
      <h2 className="text-center text-2xl font-bold my-20">
        Browse by Lodging Type
      </h2>
      <div className="container mx-auto">
        <div className="grid md:grid-cols-4 gap-4 px-4">
          {listings?.map((e) => (
            <div className="relative">
              <img src={`${e?.image}`} alt="" className="rounded-md" />
              <div className="absolute left-20 bottom-4 right-20 z-20 text-left">
                <h3 className="text-center text-2xl font-bold">
                  <Link to={e?.link}>{e?.title}</Link>
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DwellingImg;
